import React from 'react';
/*
	Este componente se fija si el usuario esta autenticado, es necesario pasarle por props user.isAuthenticated que se trae del contexto.
	Si lo esta, el componente sera un link target blank a la url que se le pase, se abre la url en una nueva pestaña.
	Si no lo esta, el componente sera un link hacia la pagina de login, con un redirectURL=partners Ej: https://{{dominio}}/login/?redirectURL=partners; para que el usuario se autentique con witwan.
*/

const PrivateLink = ({ href, children, isAuthenticated, className }) => {
  const REDIRECT_LOGIN_URL = process.env.REACT_APP_REDIRECT_LOGIN_URL;
  const DEPARTMENT = process.env.REACT_APP_API_DEPARTMENT;

  if (isAuthenticated) {
    return (
      <a
        href={href}
        target='_blank'
        rel='noopener noreferrer'
        className={`${className || ''}`}
      >
        {children}
      </a>
    );
  }
  if (!isAuthenticated) {
    return (
      <a
        href={`${window.location.origin}/${REDIRECT_LOGIN_URL}${DEPARTMENT}`}
        className={`${className || ''}`}
      >
        {children}
      </a>
    );
  }
};
export default PrivateLink;
